import React from "react";
import { useTranslation } from "react-i18next";

import { AppelServeurPreviewData, ACTION_ICONS } from "./types";
import {
    ServerCallPopupOverlay,
    ServerCallPopupModal,
    ServerCallPopupHeader,
    ServerCallPopupTitle,
    ServerCallPopupClose,
    ServerCallPopupSubtitle,
    ServerCallOptionsGrid,
    ServerCallOptionBtn,
    ServerCallOptionIcon,
    ServerCallOptionLabel,
    ServerCallCustomSection,
    ServerCallCustomLabel,
    ServerCallTextarea,
    ServerCallSubmitBtn,
} from "./styled";

type ServerCallPopupProps = {
    showServerCallPopup: boolean;
    appelServeurData?: AppelServeurPreviewData | null;
    primaryColor: string;
};

export function ServerCallPopup({
    showServerCallPopup,
    appelServeurData,
    primaryColor,
}: ServerCallPopupProps): JSX.Element | null {
    const { t } = useTranslation();

    if (
        !showServerCallPopup ||
        !appelServeurData ||
        appelServeurData.serverCallEnabled === false
    ) {
        return null;
    }

    return (
        <ServerCallPopupOverlay>
            <ServerCallPopupModal>
                <ServerCallPopupHeader>
                    <ServerCallPopupTitle>
                        {t("Call the server")}
                    </ServerCallPopupTitle>
                    <ServerCallPopupClose>
                        <svg viewBox="0 0 24 24">
                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </svg>
                    </ServerCallPopupClose>
                </ServerCallPopupHeader>
                <ServerCallPopupSubtitle>
                    {t(
                        "Choose a quick request or write your message"
                    )}
                </ServerCallPopupSubtitle>
                <ServerCallOptionsGrid>
                    {appelServeurData.quickOptions
                        .filter((opt: any) => opt.enabled)
                        .map((opt: any) => (
                            <ServerCallOptionBtn
                                key={opt.id}
                                mainColor={primaryColor}
                            >
                                <ServerCallOptionIcon
                                    mainColor={primaryColor}
                                >
                                    {opt.customIconUrl ? (
                                        <img
                                            src={opt.customIconUrl}
                                            alt=""
                                            style={{
                                                width: 16,
                                                height: 16,
                                                objectFit:
                                                    "contain",
                                            }}
                                        />
                                    ) : (
                                        <svg viewBox="0 0 24 24">
                                            <path
                                                d={
                                                    ACTION_ICONS[
                                                        opt.icon
                                                    ] ||
                                                    ACTION_ICONS.help
                                                }
                                            />
                                        </svg>
                                    )}
                                </ServerCallOptionIcon>
                                <ServerCallOptionLabel>
                                    {opt.title}
                                </ServerCallOptionLabel>
                            </ServerCallOptionBtn>
                        ))}
                </ServerCallOptionsGrid>
                {appelServeurData.customMessageEnabled && (
                    <ServerCallCustomSection>
                        <ServerCallCustomLabel>
                            {t("Custom message")}
                        </ServerCallCustomLabel>
                        <ServerCallTextarea>
                            {t("Describe your request...")}
                        </ServerCallTextarea>
                    </ServerCallCustomSection>
                )}
                <ServerCallSubmitBtn mainColor={primaryColor}>
                    <svg
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="white"
                    >
                        <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
                    </svg>
                    {t("Send request")}
                </ServerCallSubmitBtn>
            </ServerCallPopupModal>
        </ServerCallPopupOverlay>
    );
}
